import { render, staticRenderFns } from "./LapisEstrelaIcon.vue?vue&type=template&id=19916abe&scoped=true"
import script from "./LapisEstrelaIcon.vue?vue&type=script&lang=js"
export * from "./LapisEstrelaIcon.vue?vue&type=script&lang=js"
import style0 from "./LapisEstrelaIcon.vue?vue&type=style&index=0&id=19916abe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19916abe",
  null
  
)

export default component.exports